export { default } from './part-header';
